import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGravedades, getNaturalezasLesion, getZonasAfectadas, putDiagnosticoAccidente, saveDiagnosticoAccidente, } from "../../../../../redux/actions/denuncia";
import FormikActions from "../../../../commons/formik/FormikActions";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import { StyledNuevaDenuncia } from "../../../../styled/Siniestros";
import { agregarDiagnosticoAccidenteValidation } from "../validation/formValidation";

const DiagnosticoAccidenteDialog = ({
  onEdit,
  handleClose,
  open,
  diagnostico,
  setOnEditFalse,
  disabledCheck,
  firstDiag,
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    diagnosticoOms: null,
    gravedad: null,
    principal: firstDiag,
    naturalezaLesion: null,
    zonaAfectada: null,
  };

  const diagnosticoOMS = useSelector((state) => state.denuncia.diagnosticosOMS);
  const gravedades = useSelector((state) => state.denuncia.gravedades);
  const zonasAfectadas = useSelector((state) => state.denuncia.zonasAfectadas);
  const naturalezasLesion = useSelector(
    (state) => state.denuncia.naturalezasLesion
  );

  const [indice, setIndice] = useState(1);
  const [diagnosticoState, setDiagnosticoState] = useState(initialValues);
  const [descAmbitoDeteccion, setDescAmbitoDeteccion] = useState("");
  const [descGravedad, setDescGravedad] = useState("");
  const [descZonasAfectadas, setDescZonasAfectadas] = useState("");
  const [descNaturalezaLesion, setDescNaturalezaLesion] = useState("");
  const [descDiagnosticoOms, setDescDiagnosticoOms] = useState("");

  useEffect(() => {
    if (diagnostico) {
      setDiagnosticoState(diagnostico);
    }
  }, [diagnostico]);

  const handleSumbit = (values) => {
    if (onEdit) {
      const valores = { ...values, id: diagnosticoState.id };
      dispatch(putDiagnosticoAccidente(valores));

      setOnEditFalse();
    } else {
      values = {
        ...values,
        id: indice,
        descAmbitoDeteccion: descAmbitoDeteccion,
        descGravedad: descGravedad,
        descZonasAfectadas: descZonasAfectadas,
        descNaturalezaLesion: descNaturalezaLesion,
        descDiagnosticoOms: descDiagnosticoOms,
      };
      dispatch(saveDiagnosticoAccidente(values));
      setIndice(indice + 1);
    }
    handleClose();
  };

  const handleGetValues = (value) => {
    dispatch(getGravedades(value));
    dispatch(getNaturalezasLesion(value));
    dispatch(getZonasAfectadas(value));
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        {onEdit ? "Editar" : "Agregar"} Diagnóstico de Accidente
      </DialogTitle>
      {!diagnosticoState ? (
        <StyledNuevaDenuncia.DialogLoading>
          <CircularLoading />
        </StyledNuevaDenuncia.DialogLoading>
      ) : (
        <Formik
          initialValues={onEdit ? diagnosticoState : initialValues}
          validationSchema={agregarDiagnosticoAccidenteValidation}
          onSubmit={handleSumbit}
        >
          {({ values }) => (
            <Form>
              <DialogContent>
                <StyledNuevaDenuncia.InputContainer>

                  <StyledNuevaDenuncia.Input
                    name="diagnosticoOms"
                    label="Diagnóstico CIE-10 *"
                    fullWidth
                    options={diagnosticoOMS.data}
                    renderOption={(option) => option.nombre}
                    filterOptions={(option) => option.nombre}
                    callBack={(value) => {
                      if (value) {
                        let arr = value.nombre.split(" - ");
                        handleGetValues(value);
                        setDescDiagnosticoOms(arr[1]);
                      }
                    }}
                  />
                </StyledNuevaDenuncia.InputContainer>

                <StyledNuevaDenuncia.RowContainer>
                  <StyledNuevaDenuncia.InputContainer>

                  <StyledNuevaDenuncia.Input
                    name="gravedad"
                    label="Gravedad *"
                    fullWidth
                    options={gravedades.data}
                    renderOption={(option) => option.nombre}
                    filterOptions={(option) => option.nombre}
                    disabled={!values.diagnosticoOms}
                    getOptions={() =>
                      dispatch(getGravedades(values.diagnosticoOms))
                    }
                    callBack={(value) => {
                      if (value) {
                        setDescGravedad(value.nombre);
                      }
                    }}
                    />
                    </StyledNuevaDenuncia.InputContainer>
                  <StyledNuevaDenuncia.Checkbox
                    name="principal"
                    label="Principal"
                    disabled={disabledCheck || firstDiag}
                  />
                </StyledNuevaDenuncia.RowContainer>
                <StyledNuevaDenuncia.InputContainer>
                  <StyledNuevaDenuncia.Input
                    name="naturalezaLesion"
                    label="Naturaleza de lesión *"
                    fullWidth
                    options={naturalezasLesion.data}
                    renderOption={(option) => option.nombre}
                    filterOptions={(option) => option.nombre}
                    disabled={!values.diagnosticoOms}
                    getOptions={() =>
                      dispatch(getNaturalezasLesion(values.diagnosticoOms))
                    }
                    callBack={(value) => {
                      if (value) {
                        let array = value.nombre.split(" - ");
                        setDescNaturalezaLesion(array[1]);
                      }
                    }}
                  />
                </StyledNuevaDenuncia.InputContainer>
                <StyledNuevaDenuncia.InputContainer>

                  <StyledNuevaDenuncia.Input
                    name="zonaAfectada"
                    label="Zona afectada *"
                    fullWidth
                    options={zonasAfectadas.data}
                    renderOption={(option) => option.nombre}
                    filterOptions={(option) => option.nombre}
                    disabled={!values.diagnosticoOms}
                    getOptions={() =>
                      dispatch(getZonasAfectadas(values.diagnosticoOms))
                    }
                    callBack={(value) => {
                      if (value) {
                        let array = value.nombre.split(" - ");
                        setDescZonasAfectadas(array[1]);
                      }
                    }}
                  />
                </StyledNuevaDenuncia.InputContainer>
              </DialogContent>
              <DialogActions>
                <FormikActions handleCancel={handleClose}></FormikActions>
              </DialogActions>
            </Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};

export default DiagnosticoAccidenteDialog;
